import * as Yup from "yup";
import ValidationFields from "./ValidationFields";
import VideoEditingValidationFields from "./VideoEditingValidationFields";
const validationSchema = {
  athleteFormValidation: Yup.object({
    firstName: ValidationFields.firstName,
    lastName: ValidationFields.lastName,
    email: ValidationFields.email,
    phoneNumber: ValidationFields.phoneNumber,
    graduationYear: ValidationFields.graduationYear,
    positionPlayed: ValidationFields.positionPlayed,
    jerseyNumber: ValidationFields.jerseyNumber,
    instaUrl: ValidationFields.instaUrl,
    twitterUrl: ValidationFields.twitterUrl,
  }),
  schoolProfileValidation: Yup.object({
    schoolName: ValidationFields.schoolName,
    schoolType: ValidationFields.schoolType,
    firstName: ValidationFields.firstName,
    lastName: ValidationFields.lastName,
    country: ValidationFields.country,
    state: ValidationFields.state,
    email: ValidationFields.email,
    phoneNumber: ValidationFields.phoneNumber,
    sport: ValidationFields.sport,
    playLevel: ValidationFields.playLevel,
  }),
  editSchoolProfileValidation: Yup.object({
    schoolName: ValidationFields.schoolName,
    schoolType: ValidationFields.schoolType,
    firstName: ValidationFields.firstName,
    lastName: ValidationFields.lastName,
    country: ValidationFields.country,
    state: ValidationFields.state,
    status: ValidationFields.status,
    plan: ValidationFields.plan,
    email: ValidationFields.email,
    phoneNumber: ValidationFields.phoneNumber,
    sport: ValidationFields.sport,
    playLevel: ValidationFields.playLevel,
  }),
  addSchoolProfileValidation: Yup.object({
    schoolName: ValidationFields.schoolName,
    schoolType: ValidationFields.schoolType,
    firstName: ValidationFields.firstName,
    lastName: ValidationFields.lastName,
    country: ValidationFields.country,
    state: ValidationFields.state,
    plan: ValidationFields.plan,
    email: ValidationFields.email,
    phoneNumber: ValidationFields.phoneNumber,
    sport: ValidationFields.sport,
    playLevel: ValidationFields.playLevel,
  }),
  coachFormValidation: Yup.object({
    firstName: ValidationFields.firstName,
    lastName: ValidationFields.lastName,
    email: ValidationFields.email,
    phoneNumber: ValidationFields.phoneNumber,
    speciality: ValidationFields.speciality,
  }),
  eventFormValidation: Yup.object({
    eventName: ValidationFields.eventName,
    teamName: ValidationFields.teamName,
    eventType: ValidationFields.eventType,
    eventLocation: ValidationFields.eventLocation,
    eventDescription: ValidationFields.eventDescription,
    eventDate: ValidationFields.eventDate,
    eventTime: ValidationFields.eventTime,
    newTeamName: ValidationFields.newTeamName,
  }),
  groupSchema: Yup.object({
    groupName: ValidationFields.groupName,
  }),
  paymentDetailsSchema: Yup.object({
    schoolName: ValidationFields.schoolId,
    paymentMethod: ValidationFields.paymentMethod,
    note: ValidationFields.note,
    amount: ValidationFields.amount,
    paymentStatus: ValidationFields.paymentStatus,
    validity: ValidationFields.validity,
    invoiceId: ValidationFields.invoice,
  }),
  addQuestionAnswer: Yup.object({
    question: ValidationFields.question,
    answer: ValidationFields.answer,
  }),
  contactUsDetails: Yup.object({
    contactHeading: ValidationFields.contactHeading,
    contactSubHeading: ValidationFields.contactSubHeading,
  }),
  headerMenuDetails: Yup.object({
    menuLink1: ValidationFields.menuLink1,
    menuLink2: ValidationFields.menuLink2,
    menuLink3: ValidationFields.menuLink3,
    menuLink4: ValidationFields.menuLink4,
    menuLink5: ValidationFields.menuLink5,
    menuLink6: ValidationFields.menuLink6,
  }),
  footerDetailsSchema: Yup.object({
    footerDetails: ValidationFields.foterDetails,
    facebookLink: ValidationFields.facebookLink,
    twitterLink: ValidationFields.twitterLink,
    linkedInLink: ValidationFields.linkedInLink,
    youtubeLink: ValidationFields.youtubeLink,
    instagramLink: ValidationFields.instagramLink,
  }),
  signUpSchema: Yup.object({
    firstName: ValidationFields.firstName,
    lastName: ValidationFields.lastName,
    email: ValidationFields.email,
    phoneNumber: ValidationFields.phoneNumber,
    country: ValidationFields.country,
    schoolName: ValidationFields.schoolName,
    sport: ValidationFields.sport,
    signUpMessage: ValidationFields.signUpMessage,
    schoolType: ValidationFields.schoolType,
    state: ValidationFields.state,
    playLevel: ValidationFields.playLevel,
    captchaValue: ValidationFields.captchaValue,
  }),
  companyTagline: Yup.object({
    companyTagline: ValidationFields.companyTagline,
    companySubTagline: ValidationFields.companySubTagline,
  }),
  featureSchema: Yup.object({
    feature1: ValidationFields.feature1,
    feature2: ValidationFields.feature2,
    feature3: ValidationFields.feature3,
    feature4: ValidationFields.feature4,
    feature5: ValidationFields.feature5,
    feature6: ValidationFields.feature6,
    feature7: ValidationFields.feature7,
  }),
  manageIntegrationSchema: Yup.object({
    title: ValidationFields.integrationTitle,
    details: ValidationFields.integrationDetails,
  }),
  manageSportAnalysisSchema: Yup.object({
    title: ValidationFields.sportAnalysisTitle,
    details: ValidationFields.sportAnalysisDetails,
  }),
  premiumPlanSchema: Yup.object({
    title: ValidationFields.weekTitle,
    details: ValidationFields.weekDetails,
  }),
  softwareStrengthsSchema: Yup.object({
    selectedFileName: ValidationFields.selectedFileName,
    title: ValidationFields.softwareStrengthsTitle,
    details: ValidationFields.softwareStrengthsDescription,
  }),
  testimonialsSectionSchema: Yup.object({
    title: ValidationFields.weekTitle,
    details: ValidationFields.happy_Team_description,
  }),
  addOrEditSportSchema: Yup.object({
    sport: ValidationFields.sport,
    playLevel: ValidationFields.playLevel,
  }),
  addOrEditTestimonialSchema: Yup.object({
    image: ValidationFields.selectedFileName,
    testimonialHeading: ValidationFields.testimonialTitle,
    testimonialDescription: ValidationFields.testimonialDescription,
    testimonialCaptian: ValidationFields.testimonialCaptian,
  }),
  addProductVideoSchema: Yup.object({
    video: ValidationFields.selectedFileName,
    title: ValidationFields.weekTitle,
    description: ValidationFields.weekDetails,
  }),
  contactUsSchema: Yup.object({
    name: ValidationFields.fullName,
    email: ValidationFields.email,
    phoneNumber: ValidationFields.phoneNumber,
    message: ValidationFields.signUpMessage,
    subject: ValidationFields.weekDetails,
  }),
  breakDownSchema: Yup.object({
    breakDownName: ValidationFields.breakDownName,
    breakDownType: ValidationFields.breakDownType,
    possibleValue: ValidationFields.possibleValue,
  }),
  videoRenameSchema: Yup.object({
    videoName: ValidationFields.videoName,
  }),
  newsLetterSignupSchema: Yup.object({
    email: ValidationFields.email,
  }),
  buildScheduleSchema: Yup.object({
    season: ValidationFields.breakDownType,
    event: ValidationFields.breakDownType,
    week: ValidationFields.week,
    eventType: ValidationFields.eventType2,
    eventTime: ValidationFields.eventTime,
    location: ValidationFields.location,
    opponent: ValidationFields.opponent,
    otherTeams: ValidationFields.otherTeams,
  }),
  UploadVideoSchema: Yup.object({
    uploadvideoEvent: ValidationFields.uploadvideoEvent,
    uploadVideoWeek: ValidationFields.uploadVideoWeek,
    uploadVideoEventType: ValidationFields.uploadVideoEventType,
    uploadVideoOffSeasonEventName:
      ValidationFields.uploadVideoOffSeasonEventName,
    practice: ValidationFields.practice,
    otherEventName: ValidationFields.otherEventName,
    playlistName: ValidationFields.playlistName,
  }),
  AddEventNameSchema: Yup.object({
    eventName: ValidationFields.eventName,
  }),
  AddPlaylistNameSchema: Yup.object({
    playlistName: ValidationFields.playlistName,
  }),
  ApplyFilterSchema: Yup.object({
    filterId: ValidationFields.opponent,
  }),
  AddToQuickFilterSchema: Yup.object({
    filterName: ValidationFields.filterNames,
  }),
  AddFilterSchema: Yup.object({
    breakDownName: ValidationFields.opponent,
    conditionName: ValidationFields.conditionName,
    conditionValue: "",
  }),
  EditFilterSchema: Yup.object({
    filterName: ValidationFields.opponent,
    breakdownName: ValidationFields.opponent,
    conditionName: ValidationFields.conditionName,
    conditionValue: ValidationFields.filterConditionValue,
  }),

  shareVideoSchema: Yup.object({
    shareOption: ValidationFields.opponent,
    videoTitle: ValidationFields.videoTitle,
    videoDescription: ValidationFields.videoDescription,
  }),
  createVideoStreamChannelSchema: Yup.object({
    channelId: ValidationFields.id,
    channelName: ValidationFields.opponent,
    streamUrl: ValidationFields.opponent,
    stateName: ValidationFields.opponent,
    rtmpUrl1: ValidationFields.rtmpUrl,
    rtmpUrl2: ValidationFields.rtmpUrl,
  }),
  addIVSDetailsSchema: Yup.object({
    channelName: ValidationFields.opponent,
    streamURL: ValidationFields.opponent,
    streamKey: ValidationFields.opponent,
    ingestEndpoint: ValidationFields.opponent,
  }),

  IPCameraConnectionSchema: Yup.object({
    cameraAngle: ValidationFields.opponent,
  }),

  LoginSchema: Yup.object({
    email: ValidationFields.email,
    password: ValidationFields.loginPassword,
    captchaValue: ValidationFields.captchaValue,
  }),

  forgotPasswordSchema: Yup.object().shape({
    password: ValidationFields.loginPassword,
    confirmPassword: Yup.string()
      .test("passwords-match", "Passwords must match", function (value) {
        return value === this.parent.password;
      })
      .required("Please confirm your password"),
  }),

  resetPasswordSchema: Yup.object().shape({
    oldPassword: ValidationFields.loginPassword,
    password: ValidationFields.loginPassword,
    confirmPassword: Yup.string()
      .test("passwords-match", "Passwords must match", function (value) {
        return value === this.parent.password;
      })
      .required("Please confirm your password"),
  }),

  validationSchemaForVideoEditing: Yup.object().shape({
    eventType: VideoEditingValidationFields.eventType,
    schoolId: VideoEditingValidationFields.schoolId,
    eventName: VideoEditingValidationFields.eventName,
    practiceName: VideoEditingValidationFields.practiceName,
    mediaFiles: VideoEditingValidationFields.mediaFiles,
    seasonType: VideoEditingValidationFields.seasonType,
    scheduleId: VideoEditingValidationFields.scheduleId,
    isPractice: VideoEditingValidationFields.isPractice,
    seasonId: VideoEditingValidationFields.seasonId,
    isEdited: VideoEditingValidationFields.isEdited,
  }),

  columnSetSchema: Yup.object({
    columnSet: ValidationFields.columnSet,
  }),
};

export default validationSchema;
